import { Box, CircularProgress, Divider, IconButton, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { styled } from 'styled-components';
import { DuplicateIcon } from '../Icons';
import SearchBar from '../SearchBar';
import CustomButton from '../CustomButton/CustomButton';
import CustomDataGrid2 from '../CustomDataGrid/CustomDataGrid2';
import { useNavigate, useParams } from 'react-router-dom';
import { Height } from '@mui/icons-material';
import DataNotFound from '../DataItemFound/DataNotFound';
import { Catalog } from '@src/pages/Catalogs';
import { IsMobileWidth } from '../MediaQueryUtils';
import { useAppSelector } from '@src/store/hooks';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import Listing from './Listing';
import Loading from '../Loading/Loading';

type CatalogsListingProps = {
	handleRowClick: any;
	catalogs: Catalog[];
	setCatalogs: (data: Catalog[]) => void;
	filteredCatalogs: Catalog[];
	setFilteredCatalogs: (data: Catalog[]) => void;
	loadingData: boolean;
	tabValue: string;
	setTabValue: (data: string) => void;
};

export const CatalogsListing: React.FC<CatalogsListingProps> = ({
	handleRowClick,
	catalogs,
	setCatalogs,
	filteredCatalogs,
	setFilteredCatalogs,
	loadingData,
	tabValue,
	setTabValue,
}) => {
	const navigate = useNavigate();
	const { id } = useParams();
	const [searchValue, setSearchValue] = useState('');
	const { isDrawerOpen } = useAppSelector((state) => state.UI);
	const isMobileWidth = IsMobileWidth();

	const pageContainerStyles: React.CSSProperties = {
		display: 'flex',
		flexDirection: 'column',
		overflow: 'scroll',
		width:
			isDrawerOpen && !isMobileWidth
				? 'calc(100vw - 240px)'
				: !isDrawerOpen && !isMobileWidth
				? 'calc(100vw - 64px)'
				: '100%',
	};
	//Mobile Screen States
	const [windowDimensions, setWindowDimensions] = useState({
		width: window.innerWidth,
		height: window.innerHeight,
	});

	const updateWindowDimensions = () => {
		setWindowDimensions({
			width: window.innerWidth,
			height: window.innerHeight,
		});
	};
	const columns = [
		{ field: 'id', headerName: 'Catalog ID', width: 140, align: 'center', headerAlign: 'center' },
		{
			field: 'name',
			headerName: 'Catalog Name',
			width: 230,
		},
		{
			field: 'customerName',
			headerName: 'Customer Name',
			width: 170,
		},
		{
			field: 'fromDate',
			headerName: 'From Date',
			width: 160,
		},
		{ field: 'toDate', headerName: 'To Date', width: 160 },
		{
			field: 'published',
			headerName: 'Status',
			width: 150,
			renderCell: (params: any) => (
				<span
					style={{
						color: params?.row?.isExpire
							? '#FF0000'
							: params?.row?.published
							? '#24963E'
							: '#E6AE06',
						fontWeight: 'bold',
						borderRadius: '4px',
						background: params?.row?.isExpire
							? '#FFD6D6'
							: params.row.published
							? '#EAF6EC'
							: '#FFF6DB',
						padding: '2px 6px',
					}}
				>
					{params?.row?.isExpire ? 'Expire' : params?.row?.published ? 'Published' : 'Draft'}
				</span>
			),
		},
		// {
		// 	field: 'actions',
		// 	headerName: 'Actions',
		// 	width: 200,
		// 	renderCell: (params: any) => (
		// 		<IconButton onClick={() => {}} aria-label="duplicate">
		// 			<DuplicateIcon />
		// 		</IconButton>
		// 	),
		// 	align: 'center',
		// 	headerAlign: 'center',
		// },
	];

	const onRowsSelectionHandler = (ids: any) => {
		console.log(ids);
	};

	const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
		setTabValue(newValue);
	};

	const handleSearch = (value: any) => {
		setSearchValue(value);

		const filteredCatalogs = catalogs?.filter((catalog) => {
			// Convert the search value to lowercase for case-insensitive search
			const lowerCaseValue = value?.toLowerCase();

			// Check if the catalog's name or id includes the search value
			return (
				catalog?.name?.toLowerCase()?.includes(lowerCaseValue) ||
				catalog?.id.toString()?.includes(lowerCaseValue)
			);
		});

		// Update the filtered catalogs
		setFilteredCatalogs(filteredCatalogs);
	};

	//For Mobile Screen
	useEffect(() => {
		window.addEventListener('resize', updateWindowDimensions);

		return () => {
			window.removeEventListener('resize', updateWindowDimensions);
		};
	}, []);

	useEffect(() => {
		updateWindowDimensions();
	}, []);

	if (loadingData) {
		return <Loading />;
	}

	return (
		<Listing
			catalogs={catalogs}
			columns={columns}
			searchValue={searchValue}
			handleSearch={handleSearch}
			windowDimensions={windowDimensions}
			loadingData={loadingData}
			filteredCatalogs={filteredCatalogs}
			onRowsSelectionHandler={onRowsSelectionHandler}
			handleRowClick={handleRowClick}
		/>
	);
};
